import styled, { css } from 'styled-components';
import { applyStyleModifiers, type ModifiersConfig, type ModifierKeys } from 'styled-components-modifiers';

// Import styles
import { flex, transitionMain } from 'components/styles';

// Import types
import { Modifiers } from 'types/views/styles';

const MODIFIERS: Modifiers = {
	primary: ({ theme }) => css`
		&:hover {
			svg {
				color: ${theme.configurator.color.secondary};
			}
		}
	`,
	secondary: ({ theme }) => css`
		&:hover {
			svg {
				color: ${theme.configurator.color.highlight};
			}
		}
	`
};

export const Text = styled.p`
	visibility: hidden;
	opacity: 0;
	${transitionMain()}
	width: 24rem;
	padding: 1.2rem;
	background-color: ${({ theme }) => theme.tooltip.bg.primary};
	border: 1px solid ${({ theme }) => theme.tooltip.border.primary};
	border-radius: 0.4rem;
	color: ${({ theme }) => theme.tooltip.color.primary};
	font-size: 1.2rem;
	font-weight: ${({ theme }) => theme.font.normal}
	text-align: left;

	position: absolute;
	z-index: 1;
	top: 3rem;
`;

export const Wrapper = styled.div<{ modifiers?: ModifierKeys }>`
	position: relative;
	width: 1em;
	height: 1em;
	${flex()}

	&:hover {
		${Text} {
			visibility: visible;
			opacity: 1;
		}
	}

	${applyStyleModifiers(MODIFIERS as ModifiersConfig)};
`;
